export class Color {
    public r: number = 0;
    public g: number = 0;
    public b: number = 0;

    constructor(r: number, g: number, b: number) {
        this.r = r;
        this.g = g;
        this.b = b;
    }

    hex(): string {
        return this.r.toString(16).padStart(2, '0')
             + this.g.toString(16).padStart(2, '0')
             + this.b.toString(16).padStart(2, '0');
    }
}
